import React from "react";
import { useTranslation } from "react-i18next";

const Bibliography = ({ className = "" }) => {
  const { t } = useTranslation();

  return (
    <p
      className={`text-[10px] sm:text-xs leading-snug italic text-gray-400 dark:text-gray-500 text-justify mt-4 ${className}`}
    >
      {t("dashboard.wasteDashboard.bibliography")}
    </p>
  );
};

export default Bibliography;
